import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const WritersGateIcon: React.FC<Props> = props => {
  const size = props.size || 20;
  const color = props.color || 'black';
  return <Icon name={'writers-gate'} size={size} color={color} />;
};

export default React.memo(WritersGateIcon);
